import React, { useEffect, useState } from 'react';
import { ContentBoxContainer, ContentBoxText, DictionaryLetterList, DictionaryEntryList, Spacer, Button, PenlySeo, Loader } from 'components';
import { Routes } from 'utils/routes';
import { useQuery } from '@apollo/client';
import DICTIONARY_ENTRIES_QUERY from 'queries/dictionary/dictionaryEntries';

export default function Dictionary() {
    const title = 'Forstå din privatøkonomi - find forklaringer i vores ordbog';
    const description = 'Privatøkonomi skal ikke være svært og kompliceret. Få indsigt i og forstå de mest brugte ord indenfor privatøkonomi. Se mere her.';
    const image = { url: '/static/gfx/content/penly-content-20.jpg' };
    const [ dictionaryEntries, setDictionaryEntries ] = useState([]);

    const { data, loading, error } = useQuery(DICTIONARY_ENTRIES_QUERY, {
        variables: null,
        ssr: true,
    });


    useEffect(() => {
        if (dictionaryEntries && dictionaryEntries.length === 0 && data && data.dictionaryEntries && data.dictionaryEntries.length > 0) {
            const tempDictionaryEntries = [];
            [...data.dictionaryEntries].sort((a,b) => a.title.localeCompare(b.title, 'da-DK')).forEach(entry => {
                const firstLetter = entry.title.substring(0, 1);
                let letterEntry = tempDictionaryEntries.find(e => e.letter === firstLetter);

                if (!letterEntry) {
                    letterEntry = { letter: firstLetter, entries: [] };
                    tempDictionaryEntries.push(letterEntry);
                }

                letterEntry.entries.push(entry);
            });

            setDictionaryEntries(tempDictionaryEntries);
        }
    }, [data]);

    return (
        <>
            <PenlySeo
                title={ title }
                description={ description }
                image={ image }
                url={ Routes.Dictionary.LandingPage } />

            <ContentBoxContainer className="fluid dictionaryHeader">
                <ContentBoxText className="center single80 paddingSmall">
                    <h1 className="nomb small">Find forklaringer i vores ordbog om <span className="color-highlight">privatøkonomi</span></h1>
                    <br/>
                    <p className="large largeLineheight">
                        Det skal være slut med at føle at ens privatøkonomi er for stort og kompliceret at sætte sig ind i.
                        Første skridt på vejen til at forstå din privatøkonomi er at forstå de mange komplicerede ord.
                        Denne ordbog er lavet til dig der vil forstå og tage ejerskab over din over din økonomi.
                    </p>
                </ContentBoxText>
            </ContentBoxContainer>

            { !loading ?
                <>
                    { !error && dictionaryEntries && dictionaryEntries.length > 0 ?
                        <>
                            <DictionaryLetterList dictionaryEntries={ dictionaryEntries } />
                            <DictionaryEntryList dictionaryEntries={ dictionaryEntries } />
                        </>
                        :
                        <>
                            <Spacer size="large" />
                            <ContentBoxContainer className="fluid">
                                <ContentBoxText className="center background-containersecondary paddingSmall brtl brbr">
                                    <h4>Ordbogen er under vedligeholdelse</h4>
                                    <p>
                                        Vi arbejder i øjeblikket på ordbogen.
                                        <br />
                                        Kom venligst igen senere.
                                    </p>
                                </ContentBoxText>
                            </ContentBoxContainer>
                            <Spacer size="large" />
                        </>
                    }
                </>
                :
                <>
                    <Loader show={ true } />
                </>
            }

            <ContentBoxContainer className="center">
                <ContentBoxText className="brbr single80 background-primary">
                    <h3>Vil du også vide, om du kan få en bedre tilværelse som pensionist?</h3>
                    <p className="large">
                        Start dit Penly PensionsTjek med det samme og tag det første skridt på vejen til en rigere alderdom. Det koster kun din tid.
                    </p>
                    <Spacer size="small" />
                    <div>
                        <Button color="white" href={ Routes.PensionCheck.Start }>Tag et Penly PensionsTjek</Button>
                    </div>
                </ContentBoxText>
            </ContentBoxContainer>

            <Spacer size="large" />
        </>
    );
}
